import { CalloutStyles } from '@dealstack/frontend/shared/components/Callout/Callout.styles.tsx';
import { Flex, Text, Title } from '@mantine/core';
import { ReactNode } from 'react';

interface Props {
	title: string;
	body?: string;
	imageUrl?: string;
	imageAlt?: string;
	LinkComponent?: ReactNode;
}

export const Callout = ({ title, body, imageUrl, imageAlt, LinkComponent }: Props) => {
	return (
		<CalloutStyles>
			<Flex gap="0.75rem">
				{imageUrl && (
					<Flex justify="center" align="center" className="callout-image">
						<img src={imageUrl} alt={imageAlt} />
					</Flex>
				)}

				<div className="content">
					<Title size="h4" className="title" fw={600}>
						{title}
					</Title>

					{body && <Text>{body}</Text>}

					{LinkComponent && (
						<Text fz="md" fw={600}>
							{LinkComponent}
						</Text>
					)}
				</div>
			</Flex>
		</CalloutStyles>
	);
};
